import { InputNumber } from "antd"
import { useRef } from "react"
import { roundToPrecision } from "../../helpers/math"
import { hasValue } from "../../helpers/nullable"

type PercentInputProps = {
  value?: number
  max?: number
  style?: React.CSSProperties
  allowClear?: boolean
  disabled?: boolean
  onChange?: (value: number | undefined) => void
}

const PercentInput = (props: PercentInputProps) => {
  const { allowClear, ...remainingProps } = props
  const inputRef = useRef<any>()

  const handleChange = (inputValue: number | null) => {
    const defaultValue = allowClear ? undefined : 0
    props.onChange?.(hasValue(inputValue) ? roundToPrecision(inputValue / 100, 4) : defaultValue)
  }


  return <InputNumber
    {...remainingProps}
    addonAfter="%"
    step={0.01}
    min={0}
    max={props.max ? props.max * 100 : undefined}
    ref={inputRef}
    onFocus={() => inputRef.current?.select()}
    onChange={handleChange}
    value={hasValue(props.value) ? roundToPrecision(props.value * 100, 2) : null}
  />
}

export default PercentInput
